import { com, kotlin } from '@eidu/web'
import entityApiUrl from '../baseUrl'
import Patch from './Patch'
import fetchAuthorized from '../../authorization/fetchAuthorized'
import serializeToJsonString = com.eidu.entity.util.serializeToJsonString
import PatchEntitiesRequest = com.eidu.entity.api.entities.PatchEntitiesRequest
import EntityId = com.eidu.entity.EntityId
import FieldId = com.eidu.entity.field.FieldId
import KtMap = kotlin.collections.KtMap
import PatchEntityRequest = com.eidu.entity.api.entities.PatchEntityRequest

const toReferenceSetItemsKtMap = (items?: Map<FieldId, Map<EntityId, boolean>>) => {
  const byField = new Map<FieldId, KtMap<EntityId, boolean>>()
  for (const [fieldId, byItem] of items ?? []) byField.set(fieldId, KtMap.fromJsMap(byItem))
  return KtMap.fromJsMap(byField)
}

type PatchEntitiesParameters = {
  patchesByEntityId: Map<EntityId, Patch>
}

const patchEntities = async ({ patchesByEntityId }: PatchEntitiesParameters) => {
  const response = await fetchAuthorized(
    (authContext) => `${entityApiUrl}/organizations/${authContext.organizationId}/entities`,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: serializeToJsonString(
        new PatchEntitiesRequest(
          KtMap.fromJsMap(
            new Map(
              [...patchesByEntityId].map(([id, patch]) => [
                id,
                new PatchEntityRequest(
                  patch.valuesToUpdateByFieldId
                    ? KtMap.fromJsMap(patch.valuesToUpdateByFieldId)
                    : KtMap.fromJsMap(new Map()),
                  toReferenceSetItemsKtMap(patch.referenceSetItemsToUpdateByFieldId),
                  patch.linksToUpdate ? KtMap.fromJsMap(patch.linksToUpdate) : KtMap.fromJsMap(new Map())
                ),
              ])
            )
          )
        )
      ),
      method: 'PATCH',
    }
  )
  if (response.status !== 200) throw Error(`Unexpected response code ${response.status} from patchEntities endpoint`)
}

export default patchEntities
